export type ConversationVisualSource = {
  logo_url?: string | null;
  logoUrl?: string | null;
  color?: string | null;
  AgentId?: string | null;
  ProjectId?: string | null;
};

export type RecentChatVisual =
  | { kind: 'agent-logo'; logoUrl: string }
  | { kind: 'agent-fallback' }
  | { kind: 'project'; color?: string }
  | { kind: 'none' };

function trimmed(value: string | null | undefined) {
  return typeof value === 'string' ? value.trim() : '';
}

/** Fields copied onto a sidebar row from the conversations list. */
export function conversationVisualFields(item: ConversationVisualSource): {
  logo_url?: string | null;
  color?: string | null;
} {
  const logo = item.logo_url !== undefined ? item.logo_url : item.logoUrl;
  return {
    ...(logo !== undefined ? { logo_url: logo } : {}),
    ...(item.color !== undefined ? { color: item.color } : {}),
  };
}

/**
 * Agent rows use logo_url. Project rows use color.
 * An empty logo or color still marks the row type so the fallback icon can show.
 */
export function recentChatVisual(item: ConversationVisualSource): RecentChatVisual {
  const logoRaw = item.logo_url !== undefined ? item.logo_url : item.logoUrl;
  const logoUrl = trimmed(logoRaw);
  const color = trimmed(item.color);
  const logoEmpty = logoRaw !== undefined && !logoUrl;
  const colorEmpty = item.color !== undefined && !color;

  if (logoUrl) return { kind: 'agent-logo', logoUrl };
  if (color) return { kind: 'project', color };
  if (logoEmpty && !colorEmpty) return { kind: 'agent-fallback' };
  if (colorEmpty && !logoEmpty) return { kind: 'project' };
  if (item.ProjectId && !item.AgentId) return { kind: 'project' };
  if (item.AgentId && !item.ProjectId) return { kind: 'agent-fallback' };
  return { kind: 'none' };
}
